module.exports = __webpack_public_path__ + "img/code-reviewer.997a1111.jpg";